import Text from '../components/v2BaseComponents/Text';
import { Dynamo } from '../primary-record-types';
import { getIntl } from '../utils/intl';

const intl = getIntl('useCodeStatusDescriptiveLabel', {
    fullCodeDescription:
        'Indicates that |all resuscitation measures|, including CPR, defibrillation, intubation, and advanced life support, should be performed in the event of a cardiac or respiratory arrest.',
    partialCodeDNIDescription:
        ' |"Do Not Intubate"| Specifies that resuscitation measures may be performed (e.g., CPR or defibrillation), but no breathing tube or mechanical ventilation will be used.',
    partialCodeOtherDescription:
        "Specifies |customized resuscitation measures|, such as only CPR or medications, without including other interventions like intubation or defibrillation. This option is tailored to the individual's preferences.",
    dnrDescription:
        'Indicates that |no resuscitation measures| will be taken in the event of cardiac or respiratory arrest. This includes CPR, defibrillation, intubation, or advanced life support.',
    comfortMeasureDescription:
        'A code status focused |solely on providing relief from pain and symptoms without attempting life-prolonging interventions|. This approach prioritizes comfort and quality of life, avoiding resuscitation, intubation, or other invasive treatments, typically in alignment with end-of-life care preferences.',
});

export const useCodeStatusDescriptiveLabel = (codeStatus: Dynamo.CodeStatus | null): React.ReactElement | null => {
    if (!codeStatus) return null;

    const getBaseMessage = () => {
        switch (codeStatus) {
            case 'full-code':
                return intl('fullCodeDescription');
            case 'partial-code-dni':
                return intl('partialCodeDNIDescription');
            case 'partial-code-other':
                return intl('partialCodeOtherDescription');
            case 'dnr':
                return intl('dnrDescription');
            case 'comfort-measures':
                return intl('comfortMeasureDescription');
        }
    };

    const baseMessage = getBaseMessage();
    const [start, bold, end] = baseMessage.split('|');

    return (
        <Text variant="body-1">
            {start.trim() ? <Text variant="body-1">{start}</Text> : null}
            <Text variant="bold-body-1">{bold}</Text>
            {end.trim() ? <Text variant="body-1">{end}</Text> : null}
        </Text>
    );
};
